import useGroup from './useGroup'
import useProducts from './useProducts'
import { ALLOW_PLAYLIST_THUMBNAIL_UPLOAD_GROUP } from '../components/user-group-policy/permissions'

/**
 * PENG-3783: may the current user attach a thumbnail to a playlist on this tenant?
 *
 * The club exemption lives in `adminOnlyPlaylistThumbnailUpload` (useProducts), so it applies
 * to every consumer of this hook without repetition. Hiding the affordance is a UX measure;
 * nova-api enforces the same rule on the persist path.
 *
 * @returns {boolean} true when the upload affordances should be shown
 */
export function useCanUploadPlaylistThumbnail () {
  const { adminOnlyPlaylistThumbnailUpload } = useProducts()
  const { isInGroup } = useGroup()

  if (!adminOnlyPlaylistThumbnailUpload) return true
  return isInGroup(ALLOW_PLAYLIST_THUMBNAIL_UPLOAD_GROUP)
}
